export default {
  init() {
    // JavaScript to be fired on all pages
    // When the user scrolls the page, execute myFunction
    window.onscroll = myFunction;

    // Get the header
    var header = document.getElementById('myHeader');
    var logo = document.getElementById('logo');

    // Get the offset position of the navbar
    var sticky = header.offsetTop;

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
      if (window.pageYOffset > sticky) {
        logo.classList.add('sticky');
        header.classList.add('sticky');
      } else {
        logo.classList.remove('sticky');
        header.classList.remove('sticky');
      }
    }

    $('.services-links-one-page a').click(function(event) {
      if (this.hash !== '') {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        let hash = this.hash;

        let scroll_distance = $(hash).offset().top - 160;

        $('html, body').animate({
          scrollTop: scroll_distance,
        }, scroll_distance/2, function(){

        });
        return false;
      } // End if
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js